<template>
    <div id="page">
        <div class="banners  wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms">
            <img src="~@/assets/images/aboutUs/banner.png" style="height: 300px;position: absolute;left:50%;margin-left: -960px;"  />
        </div>
        <div class="container  wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms" style="width: 1200px;">
            <div style="display: flex;align-items: center;justify-content: center;margin:50px 0;">
                <img src="~@/assets/images/aboutUs/位图(1).png" style="height: 138px;margin: 0 40px;"/>
                <img src="~@/assets/images/aboutUs/位图.png" style="height: 138px;margin: 0 40px;"/>
                <img src="~@/assets/images/aboutUs/位图(2).png" style="height: 138px;margin: 0 40px;"/>
                <img src="~@/assets/images/aboutUs/位图(3).png" style="height: 138px;margin: 0 40px;"/>
            </div>
            <div class="title-font-1  wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms">
                <h1 class="title-font-1">关于我们</h1>
                <p class="title-font-1">ABOUT US</p>
            </div>
            <div style="margin-bottom: 50px;">
                <p style="font-size: 18px;color: #000000;line-height: 40px;text-indent: 2em;">中国电子节能技术协会低碳经济专业委员会。主要致力于在低碳经济、应对气候变化领域发挥在企事业单位和政府间的纽带和桥梁作用，在有关国家部委的指导下，低碳委为有关部门提供产业调研报告130余份，促进10余家企业上市，36项节能服务项目落地，为27家会员企业完成融资需求，为百余家会员单位提供技术研发与推广、技术瓶颈课题研究、投融资、项目对接等方面的服务，中促会现有18位两院院士、128位教授级研究员、508个团体会员单位，并拥有中国低碳智库、中国碳博会、工信部人才培训基地、低碳技术创新联盟、低碳金融服务中心、工业固体废弃物产学研合作联盟等多个国家级平台。同时作为国家市场监督管理总局低碳认证技术委员会电器电子碳标签工作组职能单位，着力于中国碳标签评价、低碳经济领域信息化、低碳技术交易、绿色贸易、人才培训、标准制定、鉴定认证、技术创新和科技成果产业化等工作。</p>
                <p style="font-size: 18px;color: #000000;line-height: 40px;text-indent: 2em;">近年来，世界气候面临越来越严重的问题，温室气体浓度增加严重威胁到人类的生存环境和健康安全。减少碳排放刻不容缓，在此背景下“碳足迹”的概念应运而生。各国政府和相关机构都纷纷开展了碳足迹评价方法研究，并在碳足迹基础上推出了“碳标签”。为建立健全产品碳标签认证评价体系，引导中国企业低碳转型升级，促进绿色贸易，中国电子节能技术协会低碳经济专业委员会联合相关产学研用单位2018年先后启动编制了《电器电子产品碳足迹评价通则》、《低碳建筑产品碳标签评价规范》、《LED道路照明产品碳足迹评价规范》、《微型计算机碳足迹核算技术规范》、《移动通信手持机碳足迹核算技术规范》、《液晶显示器产品碳足迹评价规范》等10余项团体标准，并于2018年11月15日正式发布了《电器电子产品碳足迹评价通则》、《LED道路照明产品碳足迹评价规范》两项标准。团体标准的发布，将有利于我国促进绿色消费和生产方式转变，提高绿色竞争力；同时碳标签制度及绿色供应链的切入，可有效降低能耗指标，建立完整综合的标准体系。</p>
            </div>
            <div style="margin-bottom: 10px;">
                <img src="~@/assets/images/aboutUs/联系我们.png" style="width:1200px;"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AboutUs",
        data() {
            return {}
        },
        components: {},
        watch: {},
        mounted() {
            this.$nextTick(()=>{
                new this.$wow.WOW().init()
            })
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>
    .banners{
        height: 300px;
        position: relative;
    }
    .title-font-1{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 30px;
        color: #000000;
        line-height: 45px;
        text-align: center;
        font-style: normal;
    }
    .title-font-2{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        text-align: center;
        font-style: normal;
    }
    .f-20{
        font-size: 20px;
    }
    .f-26{
        font-size: 26px;
    }
    .f-30{
        font-size: 30px;
    }
    .part-2-text{
        border: 2px solid rgba(232, 239, 255, 1);
        border-radius: 35px;
        width: 300px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 15px auto;
    }
    .text{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
        text-align: left;
        font-style: normal;
    }
</style>
